import { Shark, View } from "shark-mvc";

import User from "../../models/User";

import templateContent from "./register.html";

import loginView from "../login/loginView";
import mainNavComponent from "../../components/mainNav/mainNavComponent";
import userManager from "../../controllers/userManager";

class RegisterView extends View {
	constructor () {
		super("registerView");

		this.$mainRoute = "register";
		this.setTemplate(templateContent);
	}

	beforeLoad () {
		const newUser = new User();
		Shark.set({newUser});
	}

	beforeUnload () {
		Shark.set({
			errorMessage: null,
		});
	}

	init () {
		this.addComponents([mainNavComponent]);
	}
	
	createUser () {
		const { newUser } = Shark.get();
	
		if (!newUser.isValid("register")) {
			this.showErrors();
		}
		else {
			this.resetErrors();

			userManager.register(newUser)
			.then(response => {
				if (response.status === "ok") {
					localStorage.setItem("lastUserEMail", newUser.email);
					Shark.openPage(loginView);
				}
				else {
					if (response.data?.errors?.length > 0) {
						let errorMessage = response.data.errors[0].error;
						Shark.set({
							errorMessage,
						});
					}
				}
			});
		}
	}

	createUserBtn_clickHandler () {
		this.createUser();
	}

	resetErrors () {
		document.querySelectorAll(".is-invalid").forEach(item => item.classList.remove("is-invalid"));
	}

	showErrors () {
		this.resetErrors();

		const { newUser } = Shark.get();

		for (let currProp in newUser.__errors) {
			if (newUser.__errors[currProp] === true) {
				document.querySelectorAll(`[data-sh-prop="${currProp}"]`).forEach(item => item.classList.add("is-invalid"));
			}
		}
	}
}

const registerView = new RegisterView();

Shark.registerView(registerView);

export default registerView;